import React, { useEffect, useRef, useCallback, useState } from 'react'
import styled from 'styled-components';


const prodCardImg = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_prod_image_card.webp";
const prodMMImg = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_prod_image_mm.webp";
const prodScImg = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_prod_image_sc.webp";
const prodPrivacyImg = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_prod_image_privacy.webp";
const prodBureaucracyImg = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_prod_image_bureaucracy.webp";
const mmIcon = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_mm.svg";
const scIcon = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_sc.svg";
const privacyIcon = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_privacy.svg";
const timeIcon = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_time.svg";
const bureaucracyIcon = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_bureaucracy.svg";
const cardIcon = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_card.svg";

const ProductSection = styled.section`
  width: 100%;
  max-width: 1250px;
  min-height: 564px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 25px;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 30px;
  justify-content: center;
  font-family: 'Inter', sans-serif;
  z-index: 1;

  @media (max-width: 900px) {
    min-height: 650px;
    flex-direction: column;
    gap: 6px;
    padding: 0 25px 10px 25px;
  }
`;
const ProductList = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 220px;
  max-width: 600px;

  @media (max-width: 900px) {
    min-width: 0;
    width: 100%;
  }
`;


const ProductItem = styled.div`
  color: ${({ expanded }) => (expanded ? "#DC4AE1" : "#A1A1B1")};
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 12px 0 8px 0;
  border: none;
  background: none;
  outline: none;
  transition: color 0.2s;
  position: relative;
  max-width: 300px;
  font-family: 'Inter', sans-serif;
  line-height: 1.1;

    @media (max-width: 900px) {
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    touch-action: manipulation;
    transition: none;
    
    &:active {
      color: #DC4AE1;
    }
  }
`;

const SelectionBar = styled.div`
  position: absolute;
  left: -15px;
  top: ${({ barOffset }) => barOffset || 20}px;
  width: 4px;
  height: ${({ barHeight }) => barHeight || '80%'};
  background-color: #DC4AE1;
  border-radius: 2px;
  transition: opacity 0.2s ease;
  transform-origin: center;
  animation: selectionBarGrow 0.7s cubic-bezier(0.4, 0.2, 0.2, 1) both;

  @keyframes selectionBarGrow {
    0% {
      transform: scaleY(0);
      opacity: 0;
    }
    50% {
      transform: scaleY(1.08);
      opacity: 1;
    }
    100% {
      transform: scaleY(1);
      opacity: 1;
    }
  }

  @media (max-width: 900px) {
    display: none;
  }
`;


const ProductItemWrapper = styled.div`
  position: relative;
  &:first-child ${ProductItem} {
    padding-top: 0;
  }
`;

const Arrow = styled.img`
  display: inline-block;
  margin-left: 10px;
  width: 30px;
  vertical-align: middle;
`;

const ProductDescription = styled.div`
  color: #757285;
  font-size: 0.9rem;
  margin: 2px 0 12px 0;
  max-width: 500px;
  font-family: 'Inter', sans-serif;
`;

const ProductCardCol = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 0 25px 0 0;
  min-width: 200px; 

  &.mobile-product-card {
    display: none;
    @media (max-width: 900px) {
      display: block;
      width: 100%;
      justify-content: center;
      margin: 24px 0 12px 0;
    }
  }

  &.desktop-product-card {
    display: flex;
    @media (max-width: 900px) {
      display: none;
    }
  }
`;
const ProductCard = styled.div`
  width: 100%;
  max-width: 500px;
  background: #fff;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const ProductCardImg = styled.img`
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 12px;
  display: block;

  @media (max-width: 600px) {
    max-width: 100%;
    min-width: 0;
  }
`;

const ProductCardLabel = styled.div`
  position: absolute;
  left: -40px;
  bottom: -20px;
  background: #fff;
  color: #2D0F29;
  font-size: 1rem;
  font-weight: 700;
  padding: 8px 18px 7px 16px;
  box-shadow: 0 6px 24px 0 rgba(60,60,90,0.18); 
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  font-family: 'Inter', sans-serif;

  @media (max-width: 600px) {
    left: 8px;
    bottom: 8px;
    padding: 7px 14px 7px 12px;
    font-size: 0.98rem;
  }
`;

const ProductCardLabelIcon = styled.img`
  width: 24px;
  height: 24px;
  display: block;
`;

const ProductCardTryLabel = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  background: #fff;
  color: #21283E;
  font-size: 0.98rem;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  padding: 7px 14px 7px 16px;
  border-radius: 9px;
  box-shadow: 0 4px 16px 0 rgba(60,60,90,0.13);
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 3;
  max-width: 85%;
  border: none;
  cursor: pointer;
  transition: color 0.2s, background 0.2s, transform 0.2s, box-shadow 0.2s;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  appearance: none;
  transform-origin: center;
  
  &, &:link, &:visited, &:hover, &:active {
    color: #21283E;
    text-decoration: none;
  }

  &:active {
    color: #DC4AE1;
    background: #fbe7fb;
    transform: scale(0.95);
  }

  /* Apply hover effects only on non-touch devices */
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: #DC4AE1;
      box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.4);
      transform: translateY(-2px);
      
      svg {
        animation: arrowBounce 0.75s ease 1;
      }
      
      svg path {
        stroke: #DC4AE1;
      }
    }
  }

  &:focus {
    outline: none;
    color: #21283E;
  }

  @keyframes arrowBounce {
    0%, 100% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(3px);
    }
  }

  svg {
    width: 18px;
    height: 18px;
    stroke: ${({ active }) => (active ? "#DC4AE1" : "#21283E")};
    transition: transform 0.2s;
  }

  @media (max-width: 600px) {
    top: 8px;
    left: 8px;
    padding: 6px 10px 6px 10px;
    font-size: 0.95rem;
    max-width: 95%;
  }
`;

const PreloadedCards = styled.div`
  position: absolute;
  top: -9999px;
  left: -9999px;
  visibility: hidden;
  pointer-events: none;
  opacity: 0;
`;


const DescriptionContent = styled.p`
  color: #757285;
`;

const StarBulletList = styled.ul`
  margin: 10px 0 0 0;
  padding-left: 0.5em;
  list-style-type: none;
  
  li {
    background-image: url(https://d3bb2njoyzhxtr.cloudfront.net/static/bullet_star.svg);
    background-repeat: no-repeat;
    background-position: left 0.25em;
    background-size: 14px 14px;
    padding-left: 1.8em;
    margin-bottom: 0.5em;

    strong {
    font-weight: 500;
      color: #21283E;
    }
  }
`;


const expandArrowLanding = "https://d3bb2njoyzhxtr.cloudfront.net/static/expand_arrow_landing.svg";
const proceedArrowLanding = "https://d3bb2njoyzhxtr.cloudfront.net/static/proceed_arrow_landing.svg";

const ProductSectionComponent = ({
  expanded,
  setExpanded,
  tryActive,
  setTryActive,
  handleTryClick
}) => {
  const itemRefs = useRef([]);
  const sectionRef = useRef(null);
  const isUserClick = useRef(false);
  const clickTimeout = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  const products = [
    {
      name: "Free Trial Card",
      description: (
        <DescriptionContent>
          DoNotPay's Free Trial Card gives you a secure, virtual card that protects you from surprise charges.
          <StarBulletList>
            <li><strong>Sign up safely</strong></li>
            <li><strong>Auto-decline</strong></li>
            <li><strong>Privacy protected</strong></li>
            <li><strong>No cancellation hassle</strong></li>
          </StarBulletList>
        </DescriptionContent>
      ),
      image: prodCardImg,
      icon: cardIcon,
      label: "Free Trial Card",
      link: "free-trial-card-landing"
    },
    {
      name: "Find Missing Money",
      description: (
        <DescriptionContent>
          Money slips through the cracks. We help you find it and claim it.<br />
          <StarBulletList>
            <li><strong>Unclaimed Money</strong></li>
            <li><strong>Cancel Subscriptions</strong></li>
            <li><strong>Negotiate Bills</strong></li>
          </StarBulletList>
        </DescriptionContent>
      ),
      image: prodMMImg,
      icon: mmIcon,
      label: "Missing Money",
      link: "missing-money-landing"
    },
    {
      name: "Fight Scammers",
      description: (
        <DescriptionContent>
          Scams are getting smarter, so is your defense.<br />
          <StarBulletList>
            <li><strong>Robo Revenge</strong></li>
            <li><strong>Scam Warning Letters</strong></li>
          </StarBulletList>
        </DescriptionContent>
      ),
      image: prodScImg,
      icon: scIcon,
      label: "Fight Scammers",
      link: "fight-scammers-landing"
    },
    {
      name: "Beat Bureaucracy",
      description: (
        <DescriptionContent>
          Skip the lines. Skip the forms. Skip the stress.<br />
          <StarBulletList>
            <li><strong>Fight Tickets</strong></li>
            <li><strong>Car Registration Renewal</strong></li>
            <li><strong>Get Certificates and Licenses</strong></li>
          </StarBulletList>
        </DescriptionContent>
      ),
      image: prodBureaucracyImg,
      icon: bureaucracyIcon,
      label: "Beat Bureaucracy",
      link: "beat-bureaucracy-landing"
    },
    {
      name: "Protect Your Privacy",
      description: (
        <DescriptionContent>
          Keep your data yours and keep junk out of your life.<br />
          <StarBulletList>
            <li><strong>Data Breach Protection</strong></li>
            <li><strong>Burner Phone Numbers</strong></li>
            <li><strong>Do Not Mail</strong></li>
          </StarBulletList>
        </DescriptionContent>
      ),
      image: prodPrivacyImg,
      icon: privacyIcon,
      label: "Protect Your Privacy",
      link: "protect-your-privacy-landing"
    },

  ];

  const selectionBarStyles = [
    { barOffset: 15, barHeight: '83%' },
    { barOffset: 25, barHeight: '75%' },
    { barOffset: 23, barHeight: '72%' },
    { barOffset: 25, barHeight: '74%' },
    { barOffset: 25, barHeight: '74%' },
  ];


  useEffect(() => {
    itemRefs.current = products.map((_, i) => itemRefs.current[i] || React.createRef());

    const checkMobile = () => {
      setIsMobile(window.innerWidth < 900);
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [products]);

  const handleScroll = useCallback(() => {
    if (isUserClick.current || isMobile) {
      console.log("Skipping scroll selection due to user click or mobile view", isUserClick.current, isMobile);
      if (clickTimeout.current) {
        clearTimeout(clickTimeout.current);
      }
      clickTimeout.current = setTimeout(() => {
        isUserClick.current = false;
      }, 100);
      return;
    }

    const sectionRect = sectionRef.current?.getBoundingClientRect();
    if (!sectionRect || sectionRect.bottom <= 0 || sectionRect.top >= window.innerHeight) {
      return;
    }
    const windowHeight = window.innerHeight;
    const scrollProgress = (windowHeight - sectionRect.top) / (sectionRect.height + windowHeight);

    const productCount = products.length;
    let selectedIndex;

    if (productCount === 5) {
      if (scrollProgress < 0.35) {
        selectedIndex = 0;
      } else if (scrollProgress < 0.42) {
        selectedIndex = 1;
      } else if (scrollProgress < 0.54) {
        selectedIndex = 2;
      } else if (scrollProgress < 0.60) {
        selectedIndex = 3;
      } else {
        selectedIndex = 4;
      }
    } else {
      selectedIndex = Math.min(
        Math.max(0, Math.floor(scrollProgress * productCount)),
        productCount - 1
      );
    }

    if (selectedIndex !== expanded) {
      setExpanded(selectedIndex);
    }
  }, [expanded, products.length, setExpanded, isMobile]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (clickTimeout.current) clearTimeout(clickTimeout.current);
    };
  }, [handleScroll]);

  const handleMobileProductClick = (idx) => {
    setExpanded(idx);
  };

  const handleDesktopProductClick = (idx) => {
    setExpanded(idx);

    isUserClick.current = true;

    const sectionRect = sectionRef.current?.getBoundingClientRect();
    if (sectionRect) {
      const windowHeight = window.innerHeight;
      const productCount = products.length;

      let targetProgress;

      if (productCount === 5) {
        switch (idx) {
          case 0: targetProgress = 0.30; break;
          case 1: targetProgress = 0.37; break;
          case 2: targetProgress = 0.45; break;
          case 3: targetProgress = 0.55; break;
          case 4: targetProgress = 0.60; break;
          default: targetProgress = 0.5;
        }
      } else {
        targetProgress = (idx + 0.5) / productCount;
      }

      const targetScrollTop = window.pageYOffset + sectionRect.top +
        (targetProgress * (sectionRect.height + windowHeight)) - windowHeight;

      window.scrollTo({
        top: targetScrollTop,
        behavior: 'smooth'
      });
    }
    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
    }

    clickTimeout.current = setTimeout(() => {
      isUserClick.current = false;
    }, 100);
  };

  useEffect(() => {
    products.forEach(prod => {
      const img = new Image();
      img.src = prod.image;

      const icon = new Image();
      icon.src = prod.icon;
    });
  }, [products]);
  return (
    <ProductSection ref={sectionRef}>

      <PreloadedCards>
        {products.map((prod, idx) => (
          <ProductCard key={`preload-${prod.name}`}>
            <ProductCardImg
              src={prod.image}
              alt={prod.name}
              loading="eager"
            />
            <ProductCardLabelIcon
              src={prod.icon}
              alt={`${prod.name} icon`}
              loading="eager"
            />
          </ProductCard>
        ))}
      </PreloadedCards>

      <ProductList>
        {products.map((prod, idx) => (
          <ProductItemWrapper
            key={prod.name}
            ref={itemRefs.current[idx]}
            data-product-idx={idx}
          >
            {expanded === idx && (
              <SelectionBar
                barOffset={selectionBarStyles[idx]?.barOffset}
                barHeight={selectionBarStyles[idx]?.barHeight}
              />
            )}
            <ProductItem
              expanded={expanded === idx}
              onClick={() => isMobile ? handleMobileProductClick(idx) : handleDesktopProductClick(idx)}
              onTouchStart={isMobile ? () => handleMobileProductClick(idx) : undefined}
              tabIndex={0}
              role="button"
              aria-expanded={expanded === idx}
            >
              {prod.name}
              {expanded === idx && (
                <Arrow src={expandArrowLanding} alt="Expanded" />
              )}
            </ProductItem>
            {expanded === idx && (
              <>
                <ProductDescription>{prod.description}</ProductDescription>
                <ProductCardCol className="mobile-product-card">
                  <ProductCard>
                    <ProductCardTryLabel
                      type="button"
                      active={tryActive}
                      onMouseDown={() => setTryActive(true)}
                      onMouseUp={() => setTryActive(false)}
                      onMouseLeave={() => setTryActive(false)}
                      onClick={e => handleTryClick(e, prod.link)}
                    >
                      Try this product
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.5118 19.2072L22.016 13.703L16.5117 8.19873"
                          stroke="currentColor"
                          strokeWidth="1.65127"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4.40039 13.7065H22.014"
                          stroke="currentColor"
                          strokeWidth="1.65127"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </ProductCardTryLabel>
                    <ProductCardImg
                      src={prod.image}
                      alt={prod.name}
                      loading="lazy"
                    />
                    <ProductCardLabel>
                      <ProductCardLabelIcon
                        src={prod.icon}
                        alt={`${prod.name} icon`}
                        loading="lazy"
                      />
                      {prod.name}
                    </ProductCardLabel>
                  </ProductCard>
                </ProductCardCol>
              </>
            )}
          </ProductItemWrapper>
        ))}
      </ProductList>
      <ProductCardCol className="desktop-product-card">
        <ProductCard>
          <ProductCardTryLabel
            type="button"
            active={tryActive}
            onMouseDown={() => setTryActive(true)}
            onMouseUp={() => setTryActive(false)}
            onMouseLeave={() => setTryActive(false)}
            onClick={e => handleTryClick(e, products[expanded >= 0 ? expanded : 0].link)}
          >
            Try this product
            <svg
              width="27"
              height="27"
              viewBox="0 0 27 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5118 19.2072L22.016 13.703L16.5117 8.19873"
                stroke="currentColor"
                strokeWidth="1.65127"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.40039 13.7065H22.014"
                stroke="currentColor"
                strokeWidth="1.65127"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ProductCardTryLabel>
          <ProductCardImg
            src={products[expanded >= 0 ? expanded : 0].image}
            alt={products[expanded >= 0 ? expanded : 0].name}
            loading="lazy"
          />
          <ProductCardLabel>
            <ProductCardLabelIcon
              src={products[expanded >= 0 ? expanded : 0].icon}
              alt={`${products[expanded >= 0 ? expanded : 0].name} icon`}
              loading="lazy"
            />
            {products[expanded >= 0 ? expanded : 0].name}
          </ProductCardLabel>
        </ProductCard>
      </ProductCardCol>
    </ProductSection>
  )
}


export default ProductSectionComponent